import { useState } from "react";
import { useAuthContext } from "./agencyAuthHook";
import toast from "react-hot-toast";
import { useNavigate } from 'react-router-dom'

export default function SignupHook() {
    const navigate = useNavigate()

  const apiUrl = process.env.REACT_APP_API_URL;
  const { dispatch } = useAuthContext();
  const [isLoading, setLoading] = useState(false);

  // Fetching API endpoint to register a new seller
  const agencySignup = async (data) => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          setLoading(true);
          const response = await fetch(`${apiUrl}/api/agencies/signup`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({data}),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message); 
            if(json.redirect){

              navigate('/email_verification'); 
              sessionStorage.setItem("email", data.email);
            }
            else{
              localStorage.setItem("agency", JSON.stringify(json));
              dispatch({ type: "AGENCY_LOGIN", payload: json });
              navigate('/profile')
            }
           
          } else {
            if(json.redirect){
              // Redirect to the OTP 
              navigate('/email_verification', { state: { email: data.email } }); 
            }
            reject(new Error(json.message || "Registration failed.")); 
          }
        } catch (error) {
          
          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {
          setLoading(false);
        }
      }),
      {
        loading: "Processing...",
        success: (message) => <b>{message || "Registered successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to Register."}</b>, // Use dynamic message for error
      }
    );
  };

  return { isLoading, agencySignup };
}
